import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-failure',
  templateUrl: './failure.component.html',
  styleUrls: ['./failure.component.scss'],
  standalone: false
})
export class FailureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

